import React from 'react';
import { usePageData } from '../../contexts/DataContext';
import LoadingSpinner, { LoadingSkeleton } from '../common/LoadingSpinner';
import { getIconComponent } from '../home/FeaturesSection';

const ValuesSection = () => {
  const { data: aboutPage, isLoading, error } = usePageData('aboutPage');

  if (isLoading) {
    return (
      <section className="values-section">
        <div className="container">
          <LoadingSkeleton type="text" count={1} />
          <div className="underline"></div>
          <div className="values-grid">
            {[...Array(4)].map((_, i) => (
              <div className="value-card" key={i}>
                <LoadingSkeleton type="card" count={1} />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (error || !aboutPage || !aboutPage.values) {
    return (
      <section className="values-section">
        <div className="container">
          <h2>Our Values</h2>
          <div className="underline"></div>

          <div className="values-grid">
            {[1, 2, 3, 4].map((i) => (
              <div className="value-card" key={i}>
                <div className="value-icon">🛡️</div>
                <h3>Value {i}</h3>
                <p>Description for value {i}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="values-section">
      <div className="container">
        <h2>{aboutPage.values_title}</h2>
        <div className="underline"></div>

        <div className="values-grid">
          {aboutPage.values.map((value, index) => {
            const IconComponent = getIconComponent(value.icon);
            return (
              <div className="value-card" key={index}>
                <div className="value-icon">
                  <IconComponent />
                </div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;